import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import React, { useState } from 'react';
import { AuthContext, AuthData } from '../../context/auth';
import { ConfigContext, ConfigData } from '../../context/config';
import { getDateErrors } from '../../util/util';
import DefaultDatePicker, {
	DefaultDatePickerValue,
} from '../form/DefaultDatePicker';
import LargeCenterSpinner from '../LargeCenterSpinner';
import ReportTable from './ReportTable';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		marginTop: '20px',
	},
	formControl: {
		minWidth: 300,
		maxWidth: 500,
		marginTop: '16px',
	},
}));

interface Props {
	configData: ConfigData;
	authData: AuthData;
	reportResults: any;
	loadingResults: boolean;
	onUpdate: (reqObj: any, hasErrors: boolean) => void;
}

const ClaimsReport = (props: Props) => {
	const classes = useStyles();
	const { onUpdate, reportResults, loadingResults, authData } = props;
	const [reportTimestamp, setReportTimestamp] =
		useState<DefaultDatePickerValue>(null);
	const timestampErrors = getDateErrors(
		reportTimestamp,
		null,
		null,
		true,
		authData,
	);

	const updateDate = (date: DefaultDatePickerValue) => {
		const validDate = date && !isNaN(date.getTime());
		setReportTimestamp(date);
		const req = {
			reportTimestamp: validDate ? `${(date as Date).getTime()}` : null,
		};
		// get updated errors to send back to reportsView
		const hasErrors = getDateErrors(date, null, null, true, authData);
		onUpdate(req, !hasErrors.isValid);
	};

	const renderReportDetails = () => {
		return (
			<Grid container className={classes.root}>
				<Grid item xs={12}>
					<Grid container justifyContent='center'>
						<DefaultDatePicker
							disabled={!!reportResults || loadingResults}
							id='from'
							error={!timestampErrors.isValid}
							errorMessage={
								!timestampErrors.isValid ? timestampErrors.message : null
							}
							label='As Of Date'
							showCalendar
							required
							style={{ marginRight: '10px' }}
							value={reportTimestamp}
							onChange={(date) => updateDate(date)}
						/>
					</Grid>
				</Grid>
			</Grid>
		);
	};

	return (
		<>
			{renderReportDetails()}
			{loadingResults && <LargeCenterSpinner />}
			{reportResults && <ReportTable results={reportResults} />}
		</>
	);
};

function withContext(Component: any) {
	return (props: Partial<Props>) => (
		<AuthContext.Consumer>
			{(authData) => (
				<ConfigContext.Consumer>
					{(configData) => (
						<Component {...props} configData={configData} authData={authData} />
					)}
				</ConfigContext.Consumer>
			)}
		</AuthContext.Consumer>
	);
}

export default withContext(ClaimsReport);
